import { defineMessages, plural } from "../i18n/core";

export const signupMessages = defineMessages({
  "pt-BR": {
    headline: "Experimente o E-BACKUP de graça, sem cartão.",
    pitch: "Instale o agente em algumas máquinas, rode backups de verdade e restaure o que quiser. No fim do teste você decide se continua.",
    title: "Comece seu teste grátis",
    lede: "Mandamos para o seu e-mail o link para criar a senha e a verificação em duas etapas.",
    loading: "Conferindo as condições do teste…",
    limits: "O que o teste inclui",
    limitDays: (n: number) => `${n} ${plural(n, "dia", "dias")} de teste`,
    limitSpace: (space: string) => `${space} de armazenamento`,
    limitMachines: (n: number) => `até ${n} ${plural(n, "máquina", "máquinas")}`,
    limitGrace: (n: number) => `${n} ${plural(n, "dia", "dias")} para restaurar depois do fim`,
    name: "Seu nome",
    email: "E-mail de trabalho",
    company: "Empresa",
    phone: "Telefone ou WhatsApp (opcional)",
    phoneHint: "Só para a nossa equipe tirar dúvidas durante o teste.",
    website: "Não preencha este campo",
    acceptBefore: "Li e aceito os ",
    termsLink: "Termos de uso",
    acceptMiddle: " e a ",
    privacyLink: "Política de privacidade",
    acceptAfter: ".",
    acceptRequired: "Para continuar, aceite os termos de uso e a política de privacidade.",
    fieldsRequired: "Preencha nome, e-mail e empresa.",
    submit: "Criar meu teste",
    sending: "Enviando…",
    failed: "Não foi possível fazer o cadastro agora. Tente de novo em instantes.",
    doneTitle: "Confira seu e-mail",
    doneLede: (email: string) => `Se o cadastro puder ser feito, o link chega em ${email} em instantes.`,
    doneValid: "O link vale por 72 horas. Ao abrir, você cria a senha e cadastra a verificação em duas etapas, e já pode instalar o agente.",
    doneSpam: "Não chegou? Procure na pasta de spam ou lixo eletrônico. Pedir de novo com o mesmo e-mail reenvia o link.",
    backToLogin: "Ir para a entrada",
    soldOutTitle: "Testes esgotados no momento",
    soldOutLede: "Todas as vagas de teste estão em uso. Fale com a gente que liberamos um teste para você.",
    unavailableTitle: "Cadastro indisponível agora",
    unavailableLede: "Não conseguimos carregar as condições do teste. Tente de novo em instantes ou fale com a gente.",
    whatsapp: "WhatsApp",
    mail: "E-mail",
    haveAccount: "Já tem conta? Entrar",
  },
  "en-US": {
    headline: "Try E-BACKUP for free, no credit card.",
    pitch: "Install the agent on a few machines, run real backups and restore whatever you like. At the end of the trial you decide whether to keep going.",
    title: "Start your free trial",
    lede: "We email you the link to create your password and two-step verification.",
    loading: "Checking the trial conditions…",
    limits: "What the trial includes",
    limitDays: (n: number) => `${n}-day trial`,
    limitSpace: (space: string) => `${space} of storage`,
    limitMachines: (n: number) => `up to ${n} ${plural(n, "machine", "machines")}`,
    limitGrace: (n: number) => `${n} ${plural(n, "day", "days")} to restore after the end`,
    name: "Your name",
    email: "Work email",
    company: "Company",
    phone: "Phone or WhatsApp (optional)",
    phoneHint: "Only so our team can help during the trial.",
    website: "Leave this field empty",
    acceptBefore: "I have read and accept the ",
    termsLink: "Terms of use",
    acceptMiddle: " and the ",
    privacyLink: "Privacy policy",
    acceptAfter: ".",
    acceptRequired: "To continue, accept the terms of use and the privacy policy.",
    fieldsRequired: "Fill in name, email and company.",
    submit: "Create my trial",
    sending: "Sending…",
    failed: "The sign-up could not be done right now. Try again in a moment.",
    doneTitle: "Check your email",
    doneLede: (email: string) => `If the sign-up can be done, the link arrives at ${email} in a moment.`,
    doneValid: "The link is valid for 72 hours. When you open it, you create your password and set up two-step verification, and you can install the agent right away.",
    doneSpam: "Didn't get it? Look in your spam or junk folder. Asking again with the same email resends the link.",
    backToLogin: "Go to sign in",
    soldOutTitle: "Trials sold out right now",
    soldOutLede: "Every trial slot is in use. Talk to us and we will open a trial for you.",
    unavailableTitle: "Sign-up unavailable right now",
    unavailableLede: "We could not load the trial conditions. Try again in a moment or talk to us.",
    whatsapp: "WhatsApp",
    mail: "Email",
    haveAccount: "Already have an account? Sign in",
  },
  es: {
    headline: "Prueba E-BACKUP gratis, sin tarjeta.",
    pitch: "Instala el agente en algunos equipos, haz copias de verdad y restaura lo que quieras. Al final de la prueba decides si sigues.",
    title: "Empieza tu prueba gratis",
    lede: "Te enviamos por correo el enlace para crear la contraseña y la verificación en dos pasos.",
    loading: "Consultando las condiciones de la prueba…",
    limits: "Qué incluye la prueba",
    limitDays: (n: number) => `${n} ${plural(n, "día", "días")} de prueba`,
    limitSpace: (space: string) => `${space} de almacenamiento`,
    limitMachines: (n: number) => `hasta ${n} ${plural(n, "equipo", "equipos")}`,
    limitGrace: (n: number) => `${n} ${plural(n, "día", "días")} para restaurar después del fin`,
    name: "Tu nombre",
    email: "Correo de trabajo",
    company: "Empresa",
    phone: "Teléfono o WhatsApp (opcional)",
    phoneHint: "Solo para que nuestro equipo te ayude durante la prueba.",
    website: "No completes este campo",
    acceptBefore: "He leído y acepto los ",
    termsLink: "Términos de uso",
    acceptMiddle: " y la ",
    privacyLink: "Política de privacidad",
    acceptAfter: ".",
    acceptRequired: "Para continuar, acepta los términos de uso y la política de privacidad.",
    fieldsRequired: "Completa nombre, correo y empresa.",
    submit: "Crear mi prueba",
    sending: "Enviando…",
    failed: "No se pudo hacer el registro ahora. Inténtalo de nuevo en un momento.",
    doneTitle: "Revisa tu correo",
    doneLede: (email: string) => `Si el registro se puede hacer, el enlace llega a ${email} en un momento.`,
    doneValid: "El enlace vale 72 horas. Al abrirlo, creas la contraseña y configuras la verificación en dos pasos, y ya puedes instalar el agente.",
    doneSpam: "¿No llegó? Busca en la carpeta de spam o correo no deseado. Pedirlo de nuevo con el mismo correo reenvía el enlace.",
    backToLogin: "Ir al inicio de sesión",
    soldOutTitle: "Pruebas agotadas por ahora",
    soldOutLede: "Todas las plazas de prueba están en uso. Habla con nosotros y te abrimos una prueba.",
    unavailableTitle: "Registro no disponible ahora",
    unavailableLede: "No pudimos cargar las condiciones de la prueba. Inténtalo de nuevo en un momento o habla con nosotros.",
    whatsapp: "WhatsApp",
    mail: "Correo",
    haveAccount: "¿Ya tienes cuenta? Entrar",
  },
});
